export default "__VITE_ASSET__4dDOHTCb__"